import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlHandlingStrategy } from '@angular/router';
import { NgTestComponent } from './features/ng-test/ng-test.component';
import { NgTimeComponent } from './features/ng-time/ng-time.component';
import { NgReportsComponent } from './features/ng-reports/ng-reports.component';
import { NgVacationComponent } from './features/ng-vacation/ng-vacation.component';
import { NgSalesReportsComponent } from './features/ng-sales-reports/ng-sales-reports.component';
import { NgProjectReportsComponent } from './features/ng-project-reports/ng-project-reports.component';
import { NgFixedPriceProjectsComponent } from './features/ng-fixed-price-projects/ng-fixed-price-projects.component';
import { NgProjectSummaryReportsComponent } from './features/ng-project-summary-reports/ng-project-summary-reports.component';
import { NgInvoiceComponent } from './features/ng-invoice/ng-invoice.component';
import { AboutComponent } from './features/about/about.component';
import { RootRedirectComponent } from './features/root-redirect/root-redirect.component';
import { AuthGuard } from './core/guards/auth.guard';

class HybridUrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: any) {
    return true;
  }
  extract(url: any) {
    return url;
  }
  merge(url: any, whole: any) {
    return url;
  }
}
import { NgInvoiceReportsComponent } from './features/ng-invoice-reports/ng-invoice-reports.component';
import { NgTimeStatisticsReportComponent } from './features/ng-time-statistics-report/ng-time-statistics-report.component';
import { NgSalaryComponent } from './features/ng-salary/ng-salary.component';
import { NgLogoutComponent } from './features/ng-logout/ng-logout.component';
import { NgPasswordComponent } from './features/ng-password/ng-password.component';
import { NgLoginComponent } from './features/ng-login/ng-login.component';
import { NgLoginCallbackComponent } from './features/ng-login-callback/ng-login-callback.component';
import { NgAdminComponent } from './features/ng-admin/ng-admin.component';

const routes: Routes = [
  { path: '', component: RootRedirectComponent },
  {
    path: 'ng_test',
    component: NgTestComponent,
    canActivate: [AuthGuard],
    data: { patrikOnly: true, devServerOnly: true },
  },
  { path: 'time', component: NgTimeComponent, canActivate: [AuthGuard] },
  { path: 'reports', component: NgReportsComponent, canActivate: [AuthGuard] },
  { path: 'vacation', redirectTo: 'absence', pathMatch: 'full' },
  { path: 'absence', component: NgVacationComponent, canActivate: [AuthGuard] },
  { path: 'salesReports', component: NgSalesReportsComponent, canActivate: [AuthGuard] },
  { path: 'projectReport', component: NgProjectReportsComponent, canActivate: [AuthGuard] },
  { path: 'fixedPriceProjects', component: NgFixedPriceProjectsComponent, canActivate: [AuthGuard] },
  { path: 'invoiceReports', component: NgInvoiceReportsComponent, canActivate: [AuthGuard] },
  {
    path: 'timeStatisticsReport',
    component: NgTimeStatisticsReportComponent,
    canActivate: [AuthGuard],
  },
  { path: 'projectSummaryReport', component: NgProjectSummaryReportsComponent, canActivate: [AuthGuard] },
  { path: 'invoice', component: NgInvoiceComponent, canActivate: [AuthGuard] },
  { path: 'salary', component: NgSalaryComponent, canActivate: [AuthGuard] },
  { path: 'logout', component: NgLogoutComponent, canActivate: [AuthGuard] },
  { path: 'password', component: NgPasswordComponent, canActivate: [AuthGuard] },
  { path: 'login', component: NgLoginComponent },
  { path: 'loginCallback', component: NgLoginCallbackComponent },

  { path: 'about', component: AboutComponent, canActivate: [AuthGuard] },
  {
    path: 'admin',
    component: NgAdminComponent,
    canActivate: [AuthGuard],
    data: { patrikOnly: true },
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: [{ provide: UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy }],
})
export class AppRoutingModule {}
